import React from 'react'
import Banner from "../../Components/Banner/CastingCalls"
import Casting from '../../Components/CastingCalls/CastingCalls'
import Scroll from "../../Components/ScrollToTop"

function CastingCalls() {
  return (
    <div>
      <Scroll/>
      <Banner/>
      <Casting/>
        
      
    </div>
  )
}

export default CastingCalls
